export const fra = {
  _LOGIN: {
    _EMAIL: "Email",
    _PASSWORD: "Mot de passe",
    _REMEMBER: "Se souvenir de moi",
    _LOGIN: "SE CONNECTER",
    _SIGNUP: "S'inscrire",
    _FORGOTPASSWORD: "Mot de passe oublié?",
    _NOACCOUNT: "Vous n'avez pas de compte?",
    _ERROR_EMAIL:
      "Il semble que vous ne soyez pas enregistré! Essayez à nouveau.",
    _ERROR_PASSWORD: "Mot de passe incorrect",
    _SUCCESS: "Connexion réussie",
  },
  _REGISTER: {
    _REGISTER: "Créer un compte",
    _NAME: "Nom d'utilisateur",
    _EMAIL: "Votre email",
    _PASSWORD: "Votre mot de passe",
    _CONFIRMPASSWORD: "Confirmer le mot de passe",
    _WHATSAPP: "WhatsApp",
    _TELEGRAM: "Telegram (optionnel)",
    _HAVEACCOUNT: "J'ai déjà un compte",
    _ERROR_REFERAL: "Code de parrainage incorrect",
    _ERROR_EMAIL: "Cet email existe déjà",
    _SUCCESS: "Inscription réussie",
  },
  _SIDEBAR: {
    _PAGES: "Pages",
    _OPEN: "Ouvrir la barre latérale",
    _DASHBOARD: "Accueil",
    _NETWORK: "Réseau",
    _FINANCE: "Portefeuille",
    _PACKAGES: "Forfaits",
    _SIGNOUT: "Se déconnecter",
    _LANGUAGE: "Langue",
    _PROFILE: "Profil",
    _AUTH: "Authentificateur",
  },
  _DASHBOARD: {
    _TITLE: "Solde",
    _TITLE2: "Dépôt",
    _TITLE3: "Gains Totals",
    _TITLE4: "Gains Unilevel",
    _TITLE5: "Bonus de Correspondance Infinie",
    _TITLE6: "Plan",
    _TITLE7: "Bonus de Début Unilevel",
    _TITLE8: "Bonus Binaire",
    _TITLE9: "Bonus de Correspondance Binaire",
    _TITLE10: "Bonus Résiduel COPY TRADING",
    _TOTAL: "Total",
    _TABLE3: "Liste des forfaits",
    _START: "Démarrer",
    _FINISH: "Terminer",
    _STATUS: "Statut",
    _STATUS_ACTIVE: "Actif",
    _STATUS_INACTIVE: "Inactif",
    _CURRENT: "Actuel",
    _UPGRADE: "Mettre à jour",
    _COPYMESSAGE: "Copie réussie",
    _NOTIFICATION1: "Nouveau dépôt",
    _NOTIFICATION2: "Profit Cryptotradex",
    _NOTIFICATION3: "Profit Unilevel",
    _NOTIFICATION4: "Plage infinie",
    _NOTIFICATION5: "Achat de Forfait",
    _NOTIFICATION7: "Bonus de Parrainage Direct Récurrent",
    _PREV: "Précédent",
    _NEXT: "Suivant",
    _TABLE4_A: "Opération",
    _TABLE4_B: "Profit",
    _TABLE4_C: "ROI",
    _TABLE4_D: "Date",
    _SHARED: "Partagez votre lien de parrainage",
    _TITLESHARED: "Lien de parrainage",
    _TEXTSHARED:
      "Partagez votre lien de parrainage binaire et choisissez la position où vous souhaitez placer votre invité, ou laissez-le être attribué aléatoirement.",
    _RANDOM: "Aléatoire",
    _CTFLIX:
      "Formez-vous aux modèles économiques tendance et à haute rentabilité avec le Web3.",
    _SIGNAL:
      "Obtenez les meilleurs signaux depuis un seul endroit et multipliez votre capital.",
    _COPY:
      "Ne vous souciez plus des entrées et sorties — copiez toutes les opérations en un clic.",
    _CTXII:
      "Multipliez votre capital par 12 automatiquement en partenariat avec CTX. Contactez la personne qui vous a présenté cette opportunité.",
    _ENTER: "Entrer",
    _INPOSITION: "Phase de Positionnement",
  },
  _FINANCE: {
    _DEPOSIT: "Dépôt",
    _QR: "Scannez le QR suivant ou copiez l'adresse",
    _NETWORK: "Réseau",
    _INSTRUCTIONS: "Instructions pour envoyer SOLANA (SOL)",
    _STEP1: "Assurez-vous que le réseau sélectionné est SOLANA.",
    _STEP2:
      "Envoyez le montant de SOLANA à l'adresse de portefeuille suivante.",
    _COPY: "Copier",
    _DISCLAIMER:
      "Avertissement: Nous ne sommes pas responsables des transactions effectuées en dehors du réseau SOLANA ou de l'envoi de cryptomonnaies autres que SOLANA. Toute perte de fonds due à ces erreurs sera sous la responsabilité exclusive de l'expéditeur.",
    _TABLE1: "Historique des dépôts",
    _TABLE1_A: "Ordre",
    _TABLE1_B: "Montant",
    _TABLE1_C: "Date",
    _TABLE1_D: "Statut",
    _SUCCESS: "Le forfait a été ajouté avec succès",
    _COPYMESSAGE: "L'adresse du portefeuille a été copiée avec succès",
  },
  _PACKAGES: {
    _ATTENTION:
      "Attention: Vous avez un compte entreprise. L'achat d'un forfait redémarrera le compte et tous ses avantages.",
    _PACKAGES: "Sélectionnez le meilleur plan pour vous",
    _SUBTITLE: "Vous avez 8 options",
    _BALANCE: "Dépôt de solde",
    _PACKAGE: "Forfait ",
    _PACKAGE_1: "Vous gagnerez jusqu'au niveau ",
    _PACKAGE_2: "Gagnez jusqu'à",
    _PACKAGE_3: "ROI hebdomadaire",
    _BUTTON1: "Complet",
    _BUTTON2: "Acheter",
    _CALCULATE: "Calculer le plan",
    _RECHARGE: "Vous n'avez pas assez d'argent, rechargez votre portefeuille",
    _PACKAGEMESSAGE: "Vous devez acheter un forfait supérieur",
    _SUCCESS: "Le forfait a été ajouté avec succès",
    _UPDATE: "Prix de mise à jour du forfait",
    _BASIC: "De base",
    _INTERMEDIATE: "De base + Intermédiaire",
    _ADVANCED: "De base + Intermédiaire + Avancé",
    _COMPLETED: "Terminé",
    _SIGNALS: "Signaux CTX",
    _COPY: "CopyTrading CTX",
  },
  _NETWORK: {
    _TODAY: "Aujourd'hui",
    _AVAILABLE: "Disponible",
    _WITHDRAW: "Total Retiré",
    _SEARCHLABEL: "Recherche par email",
    _SEARCH: "Chercher",
    _NETWORK: "Réseau",
    _DIRECTS: "Parrains directs",
    _SUCCESS: "Recherche réussie",
    _ERROR: "Ne fait pas partie de votre arbre.",
    _LEVEL: "Niveau",
    _USERS: "Utilisateurs",
    _AMOUNT: "Montant",
    _USERNAME: "Nom d'utilisateur",
    _EMAIL: "Email",
    _WHATSAPP: "WhatsApp",
    _PACKAGE: "Forfait",
    _LEFT: "Gauche",
    _RIGHT: "Droite",
    _TOTALLEFT: "Cumulative Total Left",
    _TOTALRIGHT: "Cumulative Total Right",
    _BINARYTEXT:
      "Pour placer votre parrainage dans l'arbre binaire, appuyez et maintenez le bouton correspondant (gauche ou droite). N'oubliez pas que cette action ne peut être effectuée qu'une seule fois, nous vous conseillons donc de bien vérifier votre sélection avant de confirmer.",
    _BINARYSUCCESS: "Transaction réussie",
    _BINARYLOADING: "Chargement...",
    _SEARCHFORUSERNAME: "Chercher par nom d'utilisateur",
    _TANK: "Réservoir de parrainage direct",
  },
  _PROFILE: {
    _TITLE: "Profil",
    _NAME: "Votre nom",
    _EMAIL: "Votre email",
    _WHATSAPP: "WhatsApp",
    _CURRENTPASSWORD: "Mot de passe actuel",
    _PASSWORD: "Nouveau mot de passe",
    _CONFIRMPASSWORD: "Confirmer le nouveau mot de passe",
    _WALLET: "Adresse de retrait",
    _ACTION: "Modifier",
    _TIPS: "Conseils",
    _TIPS_1: "Le nom doit être lisible et ne pas dépasser 20 caractères.",
    _TIPS_2:
      "Le mot de passe doit inclure des chiffres, des lettres et des symboles; plus il est complexe, mieux c'est.",
    _TIPS_3:
      "L'email ne peut pas être changé. Si vous avez besoin de modifier, veuillez contacter le support.",
    _TIPS_4:
      "L'adresse de retrait ne peut être modifiée qu'avec un authentificateur à 2 facteurs, qui doit être activé au préalable.",
    _ERROR_PASSWORD: "Erreur dans le mot de passe précédent",
    _SUCCESS: "Profil mis à jour avec succès",
    _MIN: "Retrait minimum",
    _UPDATE: "Mettre à jour le profil",
  },
  _RECOVERPASSWORD: {
    _RECOVERPASSWORD: "Mot de passe oublié?",
    _EMAIL: "Votre email",
    _BUTTON: "Envoyer l'email",
    _MESSAGE: "Votre mot de passe a été envoyé à votre email",
    _ERROR_EMAIL: "Cet email n'est pas enregistré",
  },
  _GLOBALV: {
    _TITLE: "GV",
    _CURRENT: "Rang actuel",
    _NEXT: "Prochain rang",
    _SILVER: "Argent",
    _GOLD: "Or",
    _RUBY: "Rubis",
    _EMERALD: "Émeraude",
    _DIAMOND: "Diamant",
    _DIAMONDB: "Diamant Bleu",
    _DIAMONDBB: "Diamant Noir",
    _NONE: "Aucun",
  },
  _AUTH: {
    _TITLEDEFAULT: "Changer l'adresse de retrait",
    _TITLE: "Étape 1",
    _TITLE2: "Étape 2",
    _TITLE3: "Étape 3",
    _STEP1: "Téléchargez et installez l'authentificateur sur votre appareil",
    _STEP2: "Scannez le code pour l'enregistrer",
    _FORMEMAIL: "Vérification de l'email",
    _FORMHELPEMAIL: "Entrez le code de vérification à 6 chiffres envoyé à",
    _FORMHELPAUTH:
      "Entrez le code à 6 chiffres généré par l'application Authenticator",
    _FORM1: "Pin par Authenticator",
    _FORM2: "Adresse de retrait",
    _FORMMIN: "L'adresse de retrait doit comporter 34 caractères",
    _FORMCODESEND: "Code envoyé",
    _VERIFF: "Veriff",
    _ACTION: "Vérifier et enregistrer",
    _ERROR: "Erreur, essayez à nouveau.",
    _SUCCESS: "Changement réussi",
    _RETRYOTP: "Erreur lors de l'envoi du code, essayez à nouveau.",
    _SENDOTP: "Code envoyé avec succès",
    _SUCCESSOTP: "OTP vérifié avec succès",
    _SUCCESSAUTH2F: "Authentification 2FA vérifiée avec succès",
    _ERRORCODE: "Code invalide, essayez à nouveau",
  },
  _COUNTDOWN: {
    _TITLE: "Prochain découpage:",
    _DAYS: "Jours",
    _HOURS: "Heures",
    _MINUTES: "Minutes",
    _SECONDS: "Secondes",
  },
  _WITHDRAWAL: {
    _TITLE: "Transactions de retrait",
  },
  _SYSTEM: {
    _SYSTEM: "Système",
    _GLOBAL: "Global",
    _INVESTMENT: "Retirer l'investissement",
    _INVESTMENTTEXT:
      "N'oubliez pas qu'il y a une pénalité de 35% de votre investissement",
    _ACCELERATE: "Accélérer",
    _REPORT: "Rapport d'investissement Cryptotradex",
    _PARNERT: "Informations sur le parrain",
  },
  _WITHDRAWINVESTMENT: {
    _TITLE: "Retirer l'investissement",
    _MESSAGE:
      "Retirer votre capital maintenant implique des frais opérationnels de 35% de votre investissement - gains accumulés, et il sera traité dans les 24 heures. Si vous le faites, vous arrêterez son potentiel de croissance immédiat. Décidez avec une vision à long terme!",
    _BUTTON: "Retirer",
    _BUTTONWAIT: "Retrait en cours",
  },
  _SIGNAL: {
    _NEWS: "Nouveau",
    _SIGNALS: "Signaux",
    _CHAT: "Chat exclusif",
    _OPEN: "Ouvert",
    _CLOSED: "Fermé",
    _PRICEENTRY: "Prix d'entrée",
    _PRICEEND: "Prix de clôture",
    _INITIAL: "Prix initial",
    _MAXIMUN: "Prix maximum ATH",
    _DATEATH: "Date ATH",
    _MKCAP: "Cap boursière",
  },
  _ACADEMY: {
    _NEWS: "Nouveau",
    _TITLE: "Académie",
    _WHATIS: "Qu'est-ce que Cryptotradex Academy?",
    _DESCRIPTION:
      "Apprenez à connaître les cryptomonnaies, les portefeuilles, les mèmes et Web3 avec notre plateforme en ligne conçue pour tous les niveaux.",
    _ACTION1: "Aller à l'académie",
    _DISABLED: "Un dépôt minimum de 500 USD est requis",
    _TITLANDING: "Devenez un expert en Cryptomemes",
    _DESCRIPTIONLANDING:
      "Accédez à des tutoriels exclusifs du package BRETT et apprenez à dominer le monde des MEMECOINS.",
    _ACTIONLANDING: "Inscrivez-vous maintenant et commencez à apprendre!",
    _WHATCOURSES: "Quels cours recevrez-vous?",
    _RECOMMENDS: "Vidéos recommandées",
  },
  _FREE: {
    _FREE: "Gratuit",
    _FREEFOR: "GRATUIT PENDANT LONGTEMPS",
    _SIGNALS: "Aller aux signaux",
    _LINK: "Lien de la communauté",
    _TITLE:
      "Rejoignez notre communauté WhatsApp pour obtenir des informations immédiates et en temps réel",
    _DISCLAIMER: "Avertissement",
    _CHANNEL: "Aller au canal",
    _TEXTDISCLAIMER:
      "Ces signaux ont une période d'exécution, au moment où nous les publions dans notre groupe de signaux, c'est quand nous avons atteint le profit démontré.",
    _LEGEND: "Légende",
    _NAME: "Nom du jeton",
    _URL: "Lien DexScrenner",
    _START: "Heure de début",
    _END: "Heure de fin",
    _PROFIT: "Profit",
    _VER: "Aller",
  },
  _CTFLIX: {
    _BASIC: "De base",
    _INTERMEDIATE: "Intermédiaire",
    _ADVANCED: "Avancé",
    _MODULE0: "Module initial",
    _MODULE1: "Module 1 Sécurité des cryptomonnaies",
    _MODULE2: "Module 2 Coinbase",
    _MODULE3: "Module 3 Bybit",
    _MODULE4: "Module 4 Binance",
    _MODULE5: "Module 5 Échanges",
    _MODULE6: "Module 6 Outils de base",
    _MODULE7: "Module 7 Rabby Wallet",
    _MODULE8: "Module 8 Phantom Wallet",
    _MODULE9: "Module 9 Trezor",
    _MODULE10: "Module 10 Ledger",
    _MODULE11: "Module 11 Outils Onchain",
    _MODULE12: "Module 12 Analyse OnChain",
    _MODULE13: "Module 13 GMGN",
    _MODULE14: "Module 14 Dexscreener Avancé",
    _MODULE15: "Module 15 Bot Bull x NEO",
    _ALLLANGUAGE: "Toutes les langues",
    _ALLTYPES: "Tous les types",
    _ALLLMODULES: "Tous les modules",
    _REQUIREDBASIC:
      "Mettez à jour votre forfait et accédez à des modules exclusifs tels que : Sécurité Crypto, Coinbase, Bybit, Binance, et plus de 54 vidéos éducatives !",
    _REQUIREDINTERMEDIATE:
      "Ne manquez pas des modules clés comme : Exchanges, Outils de base, et l'utilisation de Wallets comme Rabby Wallet, Phantom, Trezor et Ledger ! Mettez à jour votre forfait et conservez l'accès à tout le contenu.",
    _REQUIREDADVANCED:
      "Ne perdez pas l'accès à des outils avancés comme : Analyse Onchain, GMGN, DexScreener et apprenez à utiliser le Bot Bull Neo ! Mettez à jour votre forfait pour explorer tout le potentiel de ces plateformes.",
  },
  _COPY: {
    _TITLE: "Mon Portefeuille de Copy Trading",
    _MIN: "Dépôt minimum 300 USD",
    _BALANCE: "Solde",
    _TYPE: "Type",
    _CONSERVE: "Conservateur",
    _CONSERVEDESCRIPTION:
      "Risque faible, stabilité et préservation du capital.",
    _MODERADE: "Modéré",
    _MODERADEDESCRIPTION: "Équilibre entre risque et croissance.",
    _ADVANCED: "Agressif",
    _ADVANCEDDESCRIPTION:
      "Risque élevé, rendements potentiels élevés, forte volatilité.",
    _SLIPPAGE: "Glissement",
    _SUPPLY: "Montant à trader",
    _TIME: "Temps",
    _STATISTICS: "Statistiques",
    _DISCLAIMER:
      "Pour activer le système de copy trading, un dépôt initial d’un montant minimum de <strong class='text-red-300'>300 USD</strong> est requis. Une fois cette étape effectuée, le système passera par une phase de configuration qui peut durer entre 24 et 72 heures ouvrables. <br/> <br/> Après cette phase, le système commencera à fonctionner en temps réel, en répliquant les stratégies de notre équipe de traders. <br/> <br/> Il est important de noter que nous ne sommes pas obligés d’effectuer des opérations tous les jours. Nous n’opérons que lorsque les conditions du marché sont favorables, en évitant les risques inutiles. <br/> <br/> Ce système ne garantit pas des rendements constants. Les utilisateurs acceptent que les gains et les pertes fassent partie du comportement naturel d’un marché libre et non manipulé. Aucune réclamation ne sera acceptée en cas de pertes. <br/> <br/> Cependant, nous sommes profondément fiers de nos connaissances et de notre expérience, et nous agissons avec responsabilité dans chaque décision prise. <br/> <br/> Enfin, l’ensemble du processus de copy trading comprend une étape de configuration et de vérification manuelle, au cours de laquelle les données de l’utilisateur et les informations du système sont validées avant l’activation.",
    _ACTION: "Actions",
    _PORTFOLIO: "Portefeuille",
    _CAPITAL: "Retirer le capital",
    _EARNINGS: "Retirer les gains",
    _CONNECTION: "Connexion",
  },
  _NOTICE: {
    _NOTICE: "Avis Stellaire",
    _CRYPTOCARD: "CryptoCard arrive bientôt",
    _DESCRIPTION: "Notre carte arrive, préparez-vous à une expérience totale.",
    _NEW: "Nouveau membre ?",
    _DISCOVERY: "Découvrez tout ce que nous avons pour",
    _YOU: "vous",
    _MYBUSINESS: "Mon entreprise",
    _MYPRODUCTS: "Mes produits",
  },
  _STATISTICS: {
    _FROM: "De",
    _UNTIL: "Jusqu'à",
    _NUMBERSOPERATIONS: "Nombre de transactions",
  },
};
